const paramSearch = state => state.paramSearch;
const classes = state => state.classes;
const subjects = state => state.subjects;
const question_format = state => state.question_format;
const question = state => state.question;
const paramExam = state => state.paramExam;
const bookId = state => state.bookId;
const questionIdSelect = state => state.questionIdSelect;
const typeQuestion = state => state.typeQuestion;
const paramFilterQuestionsByExam = state => state.paramFilterQuestionsByExam;

export default {
    paramSearch,
    classes,
    subjects,
    question_format,
    question,
    paramExam,
    bookId,
    questionIdSelect,
    typeQuestion,
    paramFilterQuestionsByExam
};